!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == typeof exports ? exports.HighchartsReact = t(require("react")) : e.HighchartsReact = t(e.React);
}("undefined" != typeof self ? self : this, function (e) {
  return function (e) {
    function t(n) {
      if (r[n]) return r[n].exports;
      var o = r[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
    }
    var r = {};
    return t.m = e, t.c = r, t.d = function (e, r, n) {
      t.o(e, r) || Object.defineProperty(e, r, {
        configurable: !1,
        enumerable: !0,
        get: n
      });
    }, t.n = function (e) {
      var r = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(r, "a", r), r;
    }, t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, t.p = "", t(t.s = 0);
  }([function (e, t, r) {
    "use strict";

    function n() {
      return n = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];
          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }
        return e;
      }, n.apply(this, arguments);
    }
    function o(e) {
      return a(e) || i(e) || u(e) || c();
    }
    function c() {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function u(e, t) {
      if (e) {
        if ("string" == typeof e) return f(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? f(e, t) : void 0;
      }
    }
    function i(e) {
      if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
    }
    function a(e) {
      if (Array.isArray(e)) return f(e);
    }
    function f(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var r = 0, n = new Array(t); r < t; r++) {
        n[r] = e[r];
      }
      return n;
    }
    function s(e) {
      "@babel/helpers - typeof";

      return (s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var p = r(1),
      l = r.n(p),
      y = "undefined" != typeof window ? p.useLayoutEffect : p.useEffect,
      d = Object(p.forwardRef)(function (e, t) {
        var r = Object(p.useRef)(),
          c = Object(p.useRef)();
        return y(function () {
          function t() {
            var t = e.highcharts || "object" === ("undefined" == typeof window ? "undefined" : s(window)) && window.Highcharts,
              n = e.constructorType || "chart";
            t ? t[n] ? e.options ? c.current = t[n](r.current, e.options, e.callback ? e.callback : void 0) : console.warn('The "options" property was not passed.') : console.warn('The "constructorType" property is incorrect or some required module is not imported.') : console.warn('The "highcharts" property was not passed.');
          }
          if (c.current) {
            if (!1 !== e.allowChartUpdate) if (!e.immutable && c.current) {
              var n;
              (n = c.current).update.apply(n, [e.options].concat(o(e.updateArgs || [!0, !0])));
            } else t();
          } else t();
        }), y(function () {
          return function () {
            c.current && (c.current.destroy(), c.current = null);
          };
        }, []), Object(p.useImperativeHandle)(t, function () {
          return {
            get chart() {
              return c.current;
            },
            container: r
          };
        }, []), l.a.createElement("div", n({}, e.containerProps, {
          ref: r
        }));
      });
    t.default = Object(p.memo)(d);
  }, function (t, r) {
    t.exports = e;
  }]);
});